import React, {PureComponent} from "react"

import authentication from "@irati/auth"
import idHelper from "@irati/utils/id"
import tracking from "@irati-tracking/wallet/tenantWallet"

import WalletLink from "../../shared/WalletLink"

interface Props {
  id: string
}

class TenantWallet extends PureComponent<Props> {
  render() {
    if (!authentication.apps("wallet.tenantWallet")) {
      return null
    }

    const tenantName = authentication.business().businessName

    return (
      <WalletLink
        id={idHelper("link-tenant-wallet", this.props)}
        onClick={tracking.clickTenantWallet}
        text="platform.wallet.menu.tenant.title"
        tenantName={tenantName}
        to="/tenant" />
    )
  }
}

export default TenantWallet
